import { widgetComponents } from './widget-constants';

export const casWidgets = [
  {
    name: 'Events by Severity',
    ...widgetComponents,
  },
  {
    name: 'Events by State',
    ...widgetComponents,
  },
  {
    name: 'Events by SaaS App',
    ...widgetComponents,
  },
  {
    name: 'Malware Events by Status',
    ...widgetComponents,
  },
  {
    name: 'Phishing Events by Status',
    ...widgetComponents,
  },
  {
    name: 'Shadow SaaS Events by Status',
    ...widgetComponents,
  },
  {
    name: 'DLP Events by Status',
    ...widgetComponents,
  },
  {
    name: 'Anomaly Events by Status',
    ...widgetComponents,
  },
  {
    name: 'Top Users with File Access',
    ...widgetComponents,
  },
  {
    name: 'SaaS App Overview',
    ...widgetComponents,
  },

  {
    name: 'Threat Status',
    ...widgetComponents,
    disableTimeFrameDropdown: true,
  },
];
